import { render, staticRenderFns } from "./DeleteIconLight.vue?vue&type=template&id=4aebd7b3&scoped=true&"
import script from "./DeleteIconLight.vue?vue&type=script&lang=js&"
export * from "./DeleteIconLight.vue?vue&type=script&lang=js&"
import style0 from "./DeleteIconLight.vue?vue&type=style&index=0&id=4aebd7b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebd7b3",
  null
  
)

export default component.exports